var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-text-area',{ref:_vm.fieldName,staticClass:"email-message-template-textarea",attrs:{"value":_vm.value,"maxlength":_vm.maxLength,"field-name":_vm.fieldName,"required":""},on:{"input":function($event){return _vm.onNotificationTextAreaFieldInput({
      ...$event,
      isTextarea: true,
      refName: _vm.fieldName,
      isSmsCampaign: _vm.isSmsCampaign
    })},"change":_vm.onNotificationTextAreaFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }